import { FC } from 'react';
import AnalysisTemplate from 'components/layout/templates/analysisTemplate';
import { AnalysisNavigator } from 'routes/analysis/helpers/analysisHelpers';
import { Breadcrumb, BreadcrumbItem } from '@appkit4/react-components';
import ByBusinessGraph from './components/byBusinessGraph';
import ByProcessGraph from './components/byProcessGraph';
import UserGraph from './components/userGraph';

const Dashboard: FC = () => {
  return (
    <AnalysisTemplate>
      <Breadcrumb>
        <BreadcrumbItem>Analysis</BreadcrumbItem>
        <BreadcrumbItem>Dashboard</BreadcrumbItem>
      </Breadcrumb>
      <h1>Dashboard</h1>
      <AnalysisNavigator />
      <div className="grid 2xl:grid-cols-2 xl:grid-cols-1 gap-4">
        <div className="order-last">
          <ByProcessGraph />
        </div>
        <div className="order-first">
          <UserGraph />
          <ByBusinessGraph />
        </div>
      </div>
    </AnalysisTemplate>
  );
}

export default Dashboard;